var render = function render(){var _vm=this,_c=_vm._self._c;return _c('poster-dashboard-widget',_vm._b({staticClass:"poster-dashboard-welcome-widget poster-dashboard-welcome-widget__title"},'poster-dashboard-widget',_vm.$attrs,false),[_c('h2',{staticClass:"poster-dashboard-welcome-widget__title"},[_vm._v("\n    "+_vm._s(_vm.$t('poster.dashboard.welcome_user', { name: _vm.user.displayName }))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }